import script from "./AppUpdateNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./AppUpdateNotice.vue?vue&type=script&setup=true&lang=js"

import "./AppUpdateNotice.vue?vue&type=style&index=0&id=7c60599c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c60599c"]])

export default __exports__